import { isNullOrUndefinedOrEmptyStr } from '../../utilities/stringUtil';
import { SORT_TYPE } from '../../utilities/constants';

/**
 * 現場割り当て済みの作業員の取得
 * @param {object}param:検索パラメーター
 * @return {object}searchParam:API通信用検索パラメーター
 * */
const createSearchAssignedWorkerParam = param => {
  const searchParam = Object.create(null);
  if (
    isNullOrUndefinedOrEmptyStr(param.worker_status) === false &&
    param.worker_status.length > 0
  ) {
    searchParam.worker_status = param.worker_status;
  }

  if (isNullOrUndefinedOrEmptyStr(param.order) === false) {
    if (param.sortType === SORT_TYPE.asc.id) {
      searchParam.order = param.order + SORT_TYPE.asc.name;
    } else {
      searchParam.order = param.order + SORT_TYPE.desc.name;
    }
  }
  return searchParam;
};

/**
 * 現場割り当て済みの作業員の立場・職種更新用パラメータを作成
 * @param {object}param:更新パラメーター
 * @return {object}updateParam:API通信用更新パラメーター
 * */
const createUpdateJobAndPositionParam = param => {
  const updateParam = Object.create(null);
  updateParam.field_tree_worker_duties = param.map(it => {
    const fieldTreeWorkerPosition = Object.create(null);
    fieldTreeWorkerPosition.field_tree_worker_id = it.field_tree_worker_id;
    if (isNullOrUndefinedOrEmptyStr(it.field_tree_worker_duty) === false) {
      fieldTreeWorkerPosition.syokusyu_large_class_code =
        it.field_tree_worker_duty.syokusyu_large_class_code;
      fieldTreeWorkerPosition.syokusyu_small_class_code =
        it.field_tree_worker_duty.syokusyu_small_class_code;
      fieldTreeWorkerPosition.other_job_name =
        it.field_tree_worker_duty.other_job_name;
      fieldTreeWorkerPosition.const_org_position_cd =
        it.field_tree_worker_duty.const_org_position_cd;
      fieldTreeWorkerPosition.work_content =
        it.field_tree_worker_duty.work_content;
    }
    return fieldTreeWorkerPosition;
  });
  return updateParam;
};

/**
 *
 * */
const FieldTreeWorkersService = {
  createSearchAssignedWorkerParam,
  createUpdateJobAndPositionParam,
};

export default FieldTreeWorkersService;



// WEBPACK FOOTER //
// ./src/services/fieldTreeWorkers/FieldTreeWorkersService.js